// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3FHYY","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2acv3"};